module.exports = __webpack_public_path__ + "img/this_is_service_design_doing.0ae05c45.jpg";